module.exports = __webpack_public_path__ + "static/img/arthroscopy-09.9bd9aa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-09.jpg
// module id = +CcT
// module chunks = 52